export default {
  // 模块名称
  cameraList: {
    // 按钮类
    button: {
      save: 'Save',
      reset: 'Reset',
      conform: 'Confirm',
      cancel: 'Cancel',
      prompt: 'Prompt',
      whole: 'All',
      export: 'Export',
      import: 'Import',
      moveInto: 'Move in',
      moveOut: 'Move out',
      moreModify: 'Batch edit',
      search: 'Query',
      close: 'Close',
      back: 'Back'
    },
    // 文字标签类
    label: {
      deviceName: 'Name',
      gateName: 'gateName',
      camerGet: 'Camera property',
      deviceStatus: 'Device state',
      deviceId: 'Device ID',
      factory: 'Factory',
      areaSet: 'Show no area devices only',
      viewDetail: 'Details',
      update: 'update',
      devDetail: 'Device details',
      editDevice: 'Edit device',
      moveArea: 'Select move in area',
      yes: 'Yes',
      no: 'No',
      Offline: 'Offline',
      Online: 'Online',
      deviceSet: 'DeviceGroup Settings',
      areaSets: 'Area settings',
      listFormat: 'Device list.xlsx',
      clickEnter: 'Click to enter',
      host: 'Host ',
      one: ' number',
      etherIndoor: 'Indoors or not',
      buildName: 'Build name',
      floorCode: 'Floor code',
      deviceCode: 'Device ID',
      deviceType: 'Device type',
      lng: 'Longitude',
      buildCode: 'Building code',
      deviceDec: 'Description',
      area: 'Area',
      lat: 'Latitude',
      floorName: 'Floor name',
      attribute: 'Attributes',
      doorId: 'Door ID',
      systemName: 'System name',
      areaName: 'Area',
      equipmentGroup: 'Equipment group',
      statusName: 'Status',
      wide: 'Pixel width',
      high: 'Pixel high',
      operate: 'operation',
      port: 'Port',
      ip: 'IP',
      deviceVersion: 'Device model',
      statusNames: 'Device status',
      mac: 'MAC address',
      ipAddress: 'IP address',
      modify: 'Modify',
      brake: 'Brake machine',
      entrance: 'Entrance guard',
      alarmhost: 'Alarm host',
      fire: 'fire',
      ipc: 'IPC',
      screen: 'screen',
      pad: 'PAD',
      parking: 'The parking lot',
      videosis: 'Video analysis',
      camera: 'The camera'
    },
    // 提示类
    placeholder: {
      please: 'please choose',
      enterName: 'Please enter device name',
      lengthLess: 'Length is less than 64 characters',
      enterLng: 'Please enter longitude',
      enterLat: 'Please enter latitude'
    },
    // 消息类
    message: {
      confirmSuc: 'Please check device you want to modify.',
      chooseEnter: 'Please choose to move in device',
      chooseOut: 'Please choose to move out device',
      etherMove: 'Do you want to remove device?',
      moveOut: 'Move out device',
      moveSucc: 'Successfully removed device',
      cancelMove: 'Cancelled move out',
      checkOuter: 'Please check device you want to export',
      fileError: 'File format is incorrect',
      importSucc: 'Import file successful',
      modifySucc: 'Batch modification successful',
      chooseEnterArea: 'Please select area you want to move into',
      moveIntoSucc: 'Moved into device successfully',
      numberMorn: 'Please enter between -180 and 180, with 10 decimal places at most',
      numberMorns: 'Please enter between -90 and 90, with a maximum of 10 decimal places',
      lengthChar: 'Up to 60 characters in length',
      lengthCharNum: 'Supports up to 30 characters and only Numbers or letters',
      deviceLength: 'Please enter device description (no more than 120 words)'
    },
    // 标题类
    title: {
      noData: 'No data',
      chooseArea: 'Select device area'
    }
  }
}
